import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const Summarizer = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12711"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12711)">
          <rect
            x="-39.9861"
            y="-2"
            width="197.706"
            height="114"
            rx="6.37762"
            fill="#F4F4F4"
          />
          <rect
            x="12.4635"
            y="36.0959"
            width="38.0104"
            height="51.5193"
            rx="2.71503"
            fill="white"
            stroke="#191919"
            strokeWidth="0.927083"
          />
          <path
            d="M47.8086 36.4267L12.7947 84.741C12.7947 84.741 13.0406 86.0622 13.4784 86.539C13.9161 87.0159 14.5099 87.2838 15.1289 87.2838H47.8086C48.4277 87.2838 49.0214 87.0159 49.4592 86.539C49.897 86.0622 50.1429 85.4154 50.1429 84.741V38.9696C50.1429 38.2951 49.897 37.6484 49.4592 37.1715C49.0214 36.6946 47.8086 36.4267 47.8086 36.4267Z"
            fill="#E3E3E3"
          />
          <path
            d="M20.7412 47.552H36.5733"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7412 52.3198H41.0968"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7412 57.0877H36.5733"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7412 61.8556H41.0968"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7412 66.6232H41.0968"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7412 71.3911H41.0968"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7412 76.159H36.5733"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="12.4635"
            y="36.0959"
            width="38.0104"
            height="51.5193"
            rx="2.71503"
            stroke="#191919"
            strokeWidth="0.927083"
          />
          <rect
            x="67.4635"
            y="36.0959"
            width="38.0104"
            height="18.939"
            rx="2.50313"
            fill="white"
            stroke="#191919"
            strokeWidth="0.927083"
          />
          <path
            d="M102.809 36.4269L67.7947 53.7899C67.7947 53.7899 68.0406 54.2647 68.4784 54.4361C68.9161 54.6074 69.5099 54.7037 70.1289 54.7037H102.809C103.428 54.7037 104.021 54.6074 104.459 54.4361C104.897 54.2647 105.143 54.0323 105.143 53.7899V37.3408C105.143 37.0984 104.897 36.866 104.459 36.6946C104.021 36.5232 102.809 36.4269 102.809 36.4269Z"
            fill="#E3E3E3"
          />
          <path
            d="M75.6353 43.4727H90.4119"
            stroke="#191919"
            strokeWidth="1.1125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M75.6353 47.923H94.6338"
            stroke="#191919"
            strokeWidth="1.1125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67.5562"
            y="36.1886"
            width="37.825"
            height="18.7536"
            rx="2.41042"
            stroke="#191919"
            strokeWidth="1.1125"
          />
          <g clipPath="url(#clip0_1529_12711)">
            <path
              d="M63.3518 31.2323L68.1356 30.1748L67.0724 25.3923"
              stroke="#1E1E1E"
              strokeWidth="0.927083"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.1359 30.1747C62.6178 26.6592 55.3185 21.4681 49.6045 28.2957"
              stroke="#1E1E1E"
              strokeWidth="0.927083"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M61.9661 63.9424L60.4794 65.429L55.5239 60.4735L57.0106 58.9869C57.6713 58.3472 58.557 57.993 59.4766 58.0004C60.3961 58.0079 61.2759 58.3765 61.9262 59.0268C62.5764 59.677 62.9451 60.5568 62.9525 61.4764C62.96 62.396 62.6057 63.2816 61.9661 63.9424Z"
            fill="#FF808C"
          />
          <path
            d="M50.1125 75.7958L43.1748 77.7781L45.157 70.8403L50.1125 75.7958Z"
            fill="#FFBC44"
          />
          <path
            d="M55.5239 60.4754L45.157 70.8423L50.1125 75.7978L60.4794 65.4309L55.5239 60.4754Z"
            fill="#FFEF5E"
          />
          <path
            d="M61.9661 63.9424L60.4794 65.429L55.5239 60.4735L57.0106 58.9869C57.6713 58.3472 58.557 57.993 59.4766 58.0004C60.3961 58.0079 61.2759 58.3765 61.9262 59.0268C62.5764 59.677 62.9451 60.5568 62.9525 61.4764C62.96 62.396 62.6057 63.2816 61.9661 63.9424Z"
            stroke="#191919"
            strokeWidth="0.927083"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.1125 75.7958L43.1748 77.7781L45.157 70.8403L50.1125 75.7958Z"
            stroke="#191919"
            strokeWidth="0.927083"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.5239 60.4754L45.157 70.8423L50.1125 75.7978L60.4794 65.4309L55.5239 60.4754Z"
            stroke="#191919"
            strokeWidth="0.927083"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1529_12711">
            <rect
              width="13.5972"
              height="19.1597"
              fill="white"
              transform="translate(48 28.4681) rotate(-57.4994)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
